export enum ESecuriteMiseALEau {
    PasDeDanger = 1,
    Difficile,
    Dangereux
}